import RecurringRevenueModule from "./RecurringRevenueModule";
import RecurringRevenueSagas from "./redux/RecurringRevenueSagas";
import RecurringRevenueReducer from "./redux/RecurringRevenueReducer";

export default {
  Component: RecurringRevenueModule,
  moduleName: "recurringRevenue",
  saga: RecurringRevenueSagas(),
  reducer: RecurringRevenueReducer
};
